/** Deal/geo country name -> canonical name for centroid lookup (includes world-atlas names) */
const COUNTRY_TO_CANONICAL = {
  'united kingdom': 'United Kingdom', uk: 'United Kingdom', 'great britain': 'United Kingdom', england: 'United Kingdom', gb: 'United Kingdom',
  'united states': 'USA', usa: 'USA', us: 'USA', 'united states of america': 'USA',
  australia: 'Australia', 'new zealand': 'New Zealand', canada: 'Canada', ca: 'Canada', france: 'France',
  germany: 'Germany', netherlands: 'Netherlands', 'the netherlands': 'Netherlands',
  ireland: 'Ireland', 'republic of ireland': 'Ireland', singapore: 'Singapore',
  'hong kong': 'Hong Kong', 'south africa': 'South Africa', 'united arab emirates': 'United Arab Emirates',
  uae: 'United Arab Emirates', spain: 'Spain', italy: 'Italy', india: 'India', japan: 'Japan',
  brazil: 'Brazil', mexico: 'Mexico', belgium: 'Belgium', sweden: 'Sweden', norway: 'Norway',
  denmark: 'Denmark', portugal: 'Portugal', poland: 'Poland', austria: 'Austria',
  switzerland: 'Switzerland', finland: 'Finland', malaysia: 'Malaysia', indonesia: 'Indonesia',
  philippines: 'Philippines', thailand: 'Thailand', vietnam: 'Vietnam',
  'south korea': 'South Korea', korea: 'South Korea', 'north korea': 'North Korea', taiwan: 'Taiwan', israel: 'Israel',
  'saudi arabia': 'Saudi Arabia', egypt: 'Egypt', nigeria: 'Nigeria', kenya: 'Kenya',
  ghana: 'Ghana', chile: 'Chile', colombia: 'Colombia', argentina: 'Argentina',
  russia: 'Russia', china: 'China', 'dominican rep.': 'Dominican Republic', 'dem. rep. congo': 'Democratic Republic of the Congo',
  'w. sahara': 'Western Sahara', kazakhstan: 'Kazakhstan', uzbekistan: 'Uzbekistan',
  'papua new guinea': 'Papua New Guinea', somalia: 'Somalia', sudan: 'Sudan', chad: 'Chad',
  haiti: 'Haiti', bahamas: 'Bahamas', 'falkland is.': 'Falkland Islands', greenland: 'Greenland',
  'timor-leste': 'Timor-Leste', lesotho: 'Lesotho', uruguay: 'Uruguay', bolivia: 'Bolivia',
  peru: 'Peru', panama: 'Panama', 'costa rica': 'Costa Rica', nicaragua: 'Nicaragua',
  honduras: 'Honduras', 'el salvador': 'El Salvador', guatemala: 'Guatemala', belize: 'Belize',
  venezuela: 'Venezuela', guyana: 'Guyana', suriname: 'Suriname', ecuador: 'Ecuador',
  'puerto rico': 'Puerto Rico', jamaica: 'Jamaica', cuba: 'Cuba', zimbabwe: 'Zimbabwe',
  botswana: 'Botswana', namibia: 'Namibia', senegal: 'Senegal', mali: 'Mali', mauritania: 'Mauritania',
  benin: 'Benin', niger: 'Niger', cameroon: 'Cameroon', togo: 'Togo', "côte d'ivoire": "Côte d'Ivoire",
  guinea: 'Guinea', 'guinea-bissau': 'Guinea-Bissau', liberia: 'Liberia', 'sierra leone': 'Sierra Leone',
  'burkina faso': 'Burkina Faso', 'central african rep.': 'Central African Republic', congo: 'Congo',
  gabon: 'Gabon', 'eq. guinea': 'Equatorial Guinea', zambia: 'Zambia', malawi: 'Malawi',
  mozambique: 'Mozambique', eswatini: 'eSwatini', angola: 'Angola', burundi: 'Burundi',
  lebanon: 'Lebanon', madagascar: 'Madagascar', palestine: 'Palestine', gambia: 'Gambia',
  tunisia: 'Tunisia', algeria: 'Algeria', jordan: 'Jordan', qatar: 'Qatar', kuwait: 'Kuwait',
  iraq: 'Iraq', oman: 'Oman', vanuatu: 'Vanuatu', cambodia: 'Cambodia', laos: 'Laos',
  myanmar: 'Myanmar', bangladesh: 'Bangladesh', bhutan: 'Bhutan', nepal: 'Nepal', pakistan: 'Pakistan',
  afghanistan: 'Afghanistan', tajikistan: 'Tajikistan', kyrgyzstan: 'Kyrgyzstan', turkmenistan: 'Turkmenistan',
  iran: 'Iran', syria: 'Syria', armenia: 'Armenia', belarus: 'Belarus', ukraine: 'Ukraine',
  hungary: 'Hungary', moldova: 'Moldova', romania: 'Romania', lithuania: 'Lithuania', latvia: 'Latvia',
  estonia: 'Estonia', luxembourg: 'Luxembourg', iceland: 'Iceland', azerbaijan: 'Azerbaijan', georgia: 'Georgia',
  cyprus: 'Cyprus', 'n. cyprus': 'Northern Cyprus', morocco: 'Morocco', libya: 'Libya', ethiopia: 'Ethiopia',
  djibouti: 'Djibouti', uganda: 'Uganda', rwanda: 'Rwanda', 'bosnia and herz.': 'Bosnia and Herzegovina',
  macedonia: 'North Macedonia', serbia: 'Serbia', montenegro: 'Montenegro', kosovo: 'Kosovo',
  'trinidad and tobago': 'Trinidad and Tobago', 's. sudan': 'South Sudan', yemen: 'Yemen', 'sri lanka': 'Sri Lanka',
  czechia: 'Czech Republic', slovakia: 'Slovakia', eritrea: 'Eritrea', paraguay: 'Paraguay',
};

/** Approximate [longitude, latitude] for map zoom-to-country */
export const COUNTRY_CENTROIDS = {
  'United Kingdom': [-2.5, 54],
  USA: [-95, 38],
  Australia: [133, -25],
  'New Zealand': [174, -41],
  Canada: [-106, 56],
  France: [2, 46],
  Germany: [10, 51],
  Netherlands: [5, 52],
  Ireland: [-8, 53],
  Singapore: [104, 1.3],
  Spain: [-3.5, 40],
  Italy: [12, 42.5],
  India: [78, 21],
  Japan: [138, 36],
  Brazil: [-55, -10],
  Mexico: [-102, 23],
  Belgium: [4.5, 50.5],
  Sweden: [15, 62],
  Norway: [9, 62],
  Denmark: [10, 56],
  Portugal: [-8, 39.5],
  Poland: [19, 52],
  Austria: [14.5, 47.5],
  Switzerland: [8, 47],
  Finland: [26, 64],
  'South Africa': [25, -29],
  'United Arab Emirates': [54, 24],
  'Hong Kong': [114, 22.3],
  Malaysia: [102, 4],
  Indonesia: [118, -2],
  Philippines: [122, 13],
  Thailand: [101, 15],
  Vietnam: [108, 16],
  'South Korea': [128, 36],
  Taiwan: [121, 24],
  Israel: [35, 31],
  'Saudi Arabia': [45, 25],
  Egypt: [30, 27],
  Nigeria: [8, 10],
  Kenya: [38, 0],
  Ghana: [-2, 8],
  Chile: [-71, -35],
  Colombia: [-72, 4],
  Argentina: [-64, -34],
  Russia: [100, 60],
  China: [105, 35],
  'North Korea': [127, 40],
  'Dominican Republic': [-70, 19],
  'Democratic Republic of the Congo': [22, -3],
  'Western Sahara': [-12, 25],
  Kazakhstan: [68, 48],
  Uzbekistan: [64, 41],
  'Papua New Guinea': [145, -6],
  Ecuador: [-78, -2],
  Ukraine: [31, 49],
  Romania: [25, 46],
  'Czech Republic': [15, 50],
};

export function getCentroid(countryName) {
  if (!countryName) return null;
  const canonical = COUNTRY_TO_CANONICAL[String(countryName).trim().toLowerCase()] || String(countryName).trim();
  return COUNTRY_CENTROIDS[canonical] || null;
}

export function toCanonicalCountryName(name) {
  if (!name) return null;
  const trimmed = String(name).trim();
  if (!trimmed) return null;
  return COUNTRY_TO_CANONICAL[trimmed.toLowerCase()] || trimmed;
}

/** Display name for filters (e.g. "United States" instead of "US"/"USA"). */
export function toDisplayCountryName(name) {
  if (!name) return null;
  const trimmed = String(name).trim();
  if (!trimmed) return null;
  const lower = trimmed.toLowerCase();
  if (lower === 'us' || lower === 'usa' || lower === 'united states' || lower === 'united states of america') {
    return 'United States';
  }
  return COUNTRY_TO_CANONICAL[lower] || trimmed;
}

/** Check if deal country matches any selected display country (handles US/USA/United States). */
export function countryMatchesSelection(dealCountry, selectedCountries) {
  if (!selectedCountries?.length) return true;
  const dealDisplay = toDisplayCountryName(dealCountry);
  if (!dealDisplay) return false;
  return selectedCountries.includes(dealDisplay);
}
